import { Component, OnInit, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalsService } from '../services/globals.service';
import { MenuItem, MenuType } from '../MenuItems';
import { FormGroup, FormControl } from '@angular/forms';
import { FormItem } from '../components/form/FormItem';
import { FieldTypes } from '../FieldTypes';
import { MenuService } from '../services/menu.service';

@Pipe({
  name: 'filter'
})
export class NavFilterPipe implements PipeTransform {
  constructor(
    public translate2: TranslateService,
    protected globals: GlobalsService
  ) {
    translate2.use(globals.langLocale.substr(0, 2));
  }
  transform(items: any[], searchText: string): any[] {
    // console.log(searchText);
    if (!items) { return []; }
    if (!searchText) { return items; }
    searchText = searchText.toLowerCase();
    return items.filter(it => {
      let childFind = false;
      this.translate2.get(it.name).subscribe((translated: string) => {
        it.name = translated;
      });
      if (it.children.length > 0) {
        it.children.filter(ic => {
          if (ic.children.length > 0) {
            ic.children.filter(icc => {
              this.translate2.get('pageNames.page_' + icc.pageId).subscribe((translated: string) => {
                icc.name = translated;
              });
              if (icc.name.toLowerCase().includes(searchText)) {
                childFind = true;
                return icc.name.toLowerCase().includes(searchText);
              }
            });
          }else{
            this.translate2.get(ic.name).subscribe((translated: string) => {
              ic.name = translated;
            });
            return ic.name.toLowerCase().includes(searchText);
          }
        });
      }else {
        return it.name.toLowerCase().includes(searchText);
      }
    });
  }
}

@Component({
  selector: 'vias-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  mt = MenuType;
  form: FormGroup;
  item: FormItem;
  menuSearchText: any;
  menuItems: MenuItem[];

  constructor(
    public translate: TranslateService,
    protected globals: GlobalsService,
    protected menu: MenuService
  ) {
    translate.use(globals.langLocale.substr(0, 2));
    this.form = new FormGroup({ menuSearch: new FormControl() });
    this.item = {
      type: FieldTypes.Text,
      name: 'menuSearch',

    };
    this.translate.get('search').subscribe((translated: string) => {
      this.item.label = translated;
    });
  }

  ngOnInit(): void {
    this.menuItems = this.getAll();
  }
  getAll(searchKey: string = ''): MenuItem[] {
    const MenuItems = this.menu.getMenu();
    const pages: number[] = [];
    this.globals.pagePermissions.forEach(e => {
      const perm = this.handlePermissions(e.permission);
      for (let i = 0; i < perm.length; i++) {
        if (perm.charAt(i) === '1') {
          pages.push(e.pageId + i);
        }
      }
    });
    const menu = MenuItems.filter(
      function f(o) {
        if (pages.includes(o.pageId)) { return true; }
        if (o.children) { return (o.children = o.children.filter(f)).length; }
      }
    );
    return menu;
  }
  handlePermissions(perm: string): string {
    let x: string = '';
    if (perm.length > 0) {
      x = Number.parseInt(perm, 16).toString(2);
      while (x.length < 50) {
        x = '0' + x;
      }
    }
    return x;
  }
  onChangeInput($event): void {
    this.menuSearchText = $event;
  }
  onMenuSearch($event): void {
    const search = $event.target.value;
    this.menuItems = this.getAll(search);
  }
}
